import React from "react";
import Article from "../../components/global/Articles/Article";
import Layout from "../../components/layout/Layout/Layout";
import Header from "../../components/layout/Header/Header";
import BaseWineSearchBar from "../../components/global/SearchBar/BaseWineSearchBar";
import { getArticleFromSlug } from "../../lib/articleRequests";

export default function ArticlePage({
  article,
  slug,
  rawContent,
  imageUrl,
  error,
}) {
  return (
    <Layout>
      <Header></Header>
      <BaseWineSearchBar className="pb-8" hideResults={true} />
      <Article
        article={article}
        slug={slug}
        rawContent={rawContent}
        imageUrl={imageUrl}
        error={error}
      />
    </Layout>
  );
}

export const getServerSideProps = async (context) => {
  const { slug } = context.params;
  try {
    const { data } = await getArticleFromSlug(slug as string);
    const article = data.article;
    const rawContent = data.raw_content;
    const imageUrl = data.image_url;
    if (article.published === false) {
      return {
        redirect: {
          destination: "/",
          permanent: false,
        },
      };
    }
    return {
      props: {
        article,
        rawContent,
        imageUrl,
        slug,
        error: null,
      },
    };
  } catch (error) {
    if (error?.data?.error === "Article not found") {
      return {
        notFound: true,
      };
    }
    return {
      props: {
        error: `Failed to fetch article data for slug ${slug}`,
      },
    };
  }
};
